"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PandoUnreadMessagesComponent = /** @class */ (function () {
    function PandoUnreadMessagesComponent() {
        this.isUnreadMessageCountHover = false;
    }
    return PandoUnreadMessagesComponent;
}());
exports.PandoUnreadMessagesComponent = PandoUnreadMessagesComponent;
